import api from '../api/axios';
import { API_ENDPOINTS } from './api.config';

// 1. DOCTOR APPOINTMENTS
export const appointmentHistoryService = {
  getHistory: async (page = 1, limit = 20) => {
    try {
      const response = await api.get(API_ENDPOINTS.DOCTORS.HISTORY, {
        params: { page, limit }
      });
      const res = response.data;
      const pg = res.pagination || {};
      return {
        success: res.success,
        data: res.appointments || [],
        pagination: {
          ...pg,
          current_page: pg.current_page || pg.page || page,
          total_pages: pg.total_pages || Math.ceil((pg.total || 0) / limit) || 1,
        }
      };
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch appointment history' };
    }
  },

  generateInvoice: async (appointmentId) => {
    try {
      const response = await api.post(API_ENDPOINTS.DOCTORS.GENERATE_INVOICE(appointmentId));
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to generate invoice' };
    }
  },

  downloadInvoice: (appointmentId) => {
    return `${api.defaults.baseURL}${API_ENDPOINTS.DOCTORS.DOWNLOAD_INVOICE(appointmentId)}`;
  }
};

// 2. MEDICINES
export const medicineOrderService = {
  getHistory: async (page = 1, limit = 20, status = '') => {
    try {
      const params = { page, limit };
      if (status) params.status = status;

      const response = await api.get(API_ENDPOINTS.ORDERS.HISTORY, { params });
      const res = response.data;
      const pg = res.pagination || {};
      return {
        success: res.success,
        data: res.orders || [],
        pagination: {
          ...pg,
          current_page: pg.current_page || pg.page || page,
          total_pages: pg.total_pages || Math.ceil((pg.total || 0) / limit) || 1,
        }
      };
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch medicine order history' };
    }
  },

  generateInvoice: async (orderId) => {
    try {
      const response = await api.post(API_ENDPOINTS.ORDERS.GENERATE_INVOICE(orderId));
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to generate invoice' };
    }
  },

  downloadInvoice: (orderId) => {
    return `${api.defaults.baseURL}${API_ENDPOINTS.ORDERS.DOWNLOAD_INVOICE(orderId)}`;
  }
};

// 3. MEDICAL TESTS
export const medicalTestHistoryService = {
  getHistory: async (page = 1, limit = 20) => {
    try {
      const response = await api.get(API_ENDPOINTS.MEDICAL_TESTS.HISTORY, {
        params: { page, limit }
      });
      const res = response.data;
      const pg = res.pagination || {};
      return {
        success: res.success,
        data: res.appointments || [],
        pagination: {
          ...pg,
          current_page: pg.current_page || pg.page || page,
          total_pages: pg.total_pages || Math.ceil((pg.total || 0) / limit) || 1,
        }
      };
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch medical test history' };
    }
  },

  generateInvoice: async (appointmentId) => {
    try {
      const response = await api.post(API_ENDPOINTS.MEDICAL_TESTS.GENERATE_INVOICE(appointmentId));
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to generate invoice' };
    }
  },

  downloadInvoice: (appointmentId) => {
    return `${api.defaults.baseURL}${API_ENDPOINTS.MEDICAL_TESTS.DOWNLOAD_INVOICE(appointmentId)}`;
  }
};

// 4. PARAMEDICAL SERVICES
export const paramedicalHistoryService = {
  getHistory: async (page = 1, limit = 20) => {
    try {
      const response = await api.get(API_ENDPOINTS.PARAMEDICAL.HISTORY, {
        params: { page, limit }
      });
      const res = response.data;
      const pg = res.pagination || {};
      return {
        success: res.success,
        data: res.appointments || [],
        pagination: {
          ...pg,
          current_page: pg.current_page || pg.page || page,
          total_pages: pg.total_pages || Math.ceil((pg.total || 0) / limit) || 1,
        }
      };
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch paramedical service history' };
    }
  },

  generateInvoice: async (appointmentId) => {
    try {
      const response = await api.post(API_ENDPOINTS.PARAMEDICAL.GENERATE_INVOICE(appointmentId));
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to generate invoice' };
    }
  },

  downloadInvoice: (appointmentId) => {
    return `${api.defaults.baseURL}${API_ENDPOINTS.PARAMEDICAL.DOWNLOAD_INVOICE(appointmentId)}`;
  }
};

// 5. ONLINE CONSULTATIONS
export const consultationHistoryService = {
  getHistory: async (page = 1, limit = 20) => {
    try {
      const response = await api.get(API_ENDPOINTS.CONSULTATIONS.HISTORY, {
        params: { page, limit }
      });
      const res = response.data;
      const pg = res.pagination || {};
      return {
        success: res.success || true,
        data: res.data || res.consultations || [],
        pagination: {
          ...pg,
          current_page: pg.current_page || pg.page || page,
          total_pages: pg.total_pages || Math.ceil((pg.total_count || pg.total || 0) / limit) || 1,
        }
      };
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch consultation history' };
    }
  },

  generateInvoice: async (consultationId) => {
    try {
      const response = await api.post(API_ENDPOINTS.CONSULTATIONS.GENERATE_INVOICE(consultationId));
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to generate invoice' };
    }
  },

  downloadInvoice: (consultationId) => {
    return `${api.defaults.baseURL}${API_ENDPOINTS.CONSULTATIONS.DOWNLOAD_INVOICE(consultationId)}`;
  }
};
